/* =============================================================================
   WAGUESS — Custom JS
   1) Announcement dismiss X (all pages)
   2) Chat: Service Client + Contact Us 2, only after CTA click
   ============================================================================= */

/* --- Announcement dismiss (global) --- */
(function () {
  var COOKIE = 'announcement';
  var COOKIE_VAL = 'closed';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function findBar() {
    return (
      document.querySelector('announcement-bar-component.announcement-bar') ||
      document.querySelector('.announcement-bar') ||
      document.querySelector('#shopify-section-announcement-bar .announcement-bar') ||
      document.querySelector('[id*="announcement-bar"] .announcement-bar')
    );
  }

  function removeBar(bar) {
    if (!bar) return;
    var section = bar.closest('.shopify-section') || bar.parentElement;
    if (section && section.classList && section.classList.contains('shopify-section')) {
      section.remove();
    } else {
      bar.remove();
    }
  }

  function ensureDismissButton(bar) {
    if (!bar) return null;
    var existing = bar.querySelector('[data-close-announcement], .waguess-announcement-close');
    if (existing) return existing;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'announcement-close waguess-announcement-close';
    btn.setAttribute('data-close-announcement', 'true');
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" aria-hidden="true"><path fill="currentColor" d="M38.98 6.97a2 2 0 0 0-1.4.62L24 21.17 10.41 7.59a2 2 0 1 0-2.83 2.83L21.17 24 7.59 37.59a2 2 0 1 0 2.83 2.83L24 26.83l13.59 13.59a2 2 0 1 0 2.83-2.83L26.83 24 40.41 10.41a2 2 0 0 0-1.43-3.44z"/></svg>';
    bar.appendChild(btn);
    return btn;
  }

  function bindDismiss(bar) {
    var btn = ensureDismissButton(bar);
    if (!btn || btn.dataset.waguessBound === '1') return;
    btn.dataset.waguessBound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setCookie(COOKIE, COOKIE_VAL, 7);
      removeBar(bar);
    });
  }

  function init() {
    if (getCookie(COOKIE) === COOKIE_VAL) {
      var closed = findBar();
      if (closed) removeBar(closed);
      return;
    }
    var bar = findBar();
    if (bar) bindDismiss(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme sections can hydrate late
  setTimeout(init, 400);
  setTimeout(init, 1200);
})();

/* --- Chat (chat pages only) --- */
(function () {
  var CHAT_HASH = '#waguess-chat';

  function isChatPage() {
    return (
      document.documentElement.classList.contains('waguess-chat-page') ||
      document.body.classList.contains('waguess-chat-page') ||
      document.documentElement.classList.contains('waguess-service-client-page') ||
      document.body.classList.contains('waguess-service-client-page') ||
      document.body.classList.contains('template-page-service-client') ||
      document.body.classList.contains('template-page-template-service-client') ||
      document.body.classList.contains('template-page-template-contact-us-2') ||
      document.body.classList.contains('template-page-contact-us-2') ||
      /\/pages\/service-client/i.test(window.location.pathname)
    );
  }

  // Chat logic only on chat-enabled pages
  if (!isChatPage()) {
    return;
  }

  function findWidgetLauncher() {
    var selectors = [
      '#chat-widget-container button',
      '#chat-widget-container [role="button"]',
      'iframe[src*="leadconnectorhq"]',
      'iframe[src*="chat-widget"]',
      '[class*="lc_text-widget"]',
      '[class*="chat-widget"] button',
      '[id*="chat-widget"] button',
      'button[aria-label*="chat" i]',
      'button[aria-label*="Chat"]',
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }

    var hosts = document.querySelectorAll('chat-widget, #chat-widget-container, [id*="chat"]');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (host.shadowRoot) {
        var btn = host.shadowRoot.querySelector('button, [role="button"]');
        if (btn) return btn;
      }
    }
    return null;
  }

  function openChatWidget() {
    document.documentElement.classList.add('waguess-chat-open');
    document.body.classList.add('waguess-chat-open');

    try {
      if (
        window.LeadConnector &&
        window.LeadConnector.chatWidget &&
        typeof window.LeadConnector.chatWidget.open === 'function'
      ) {
        window.LeadConnector.chatWidget.open();
        return true;
      }
    } catch (e) {}

    try {
      if (typeof window.openChatWidget === 'function') {
        window.openChatWidget();
        return true;
      }
    } catch (e) {}

    var launcher = findWidgetLauncher();
    if (launcher) {
      if (launcher.tagName === 'IFRAME') {
        var wrap =
          launcher.closest('#chat-widget-container, [id*="chat-widget"], [class*="chat-widget"]') ||
          launcher.parentElement;
        if (wrap) {
          wrap.style.setProperty('display', 'block', 'important');
          wrap.style.setProperty('visibility', 'visible', 'important');
          wrap.style.setProperty('opacity', '1', 'important');
          wrap.style.setProperty('pointer-events', 'auto', 'important');
        }
        launcher.style.setProperty('display', 'block', 'important');
        return true;
      }
      launcher.click();
      return true;
    }

    return false;
  }

  function openChatWithRetry() {
    var attempts = 0;
    var max = 24;
    (function tick() {
      attempts += 1;
      if (openChatWidget() || attempts >= max) return;
      setTimeout(tick, 250);
    })();
  }

  function isChatButton(el) {
    if (!el || !el.closest) return false;

    if (el.closest('[data-waguess-chat]')) return true;
    if (el.closest('.contact-btn')) return true;

    var href = el.getAttribute && el.getAttribute('href');
    if (href === CHAT_HASH || (href && href.indexOf(CHAT_HASH) !== -1)) return true;

    var label = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (
      label === 'chat with us' ||
      label === 'message us' ||
      label === 'open service client' ||
      label.indexOf('chat with us') !== -1 ||
      label.indexOf('message us') !== -1
    ) {
      return true;
    }

    return false;
  }

  // Mark page CTAs for chat (Service Client + Contact Message us)
  function enhanceChatPageCtas() {
    var links = document.querySelectorAll(
      'a.button, a.button-1, a.contact-btn, .rich-text a, .rich-text .button, main a'
    );
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (
        href.indexOf(CHAT_HASH) !== -1 ||
        label.indexOf('chat') !== -1 ||
        label.indexOf('message us') !== -1 ||
        label.indexOf('service client') !== -1 ||
        a.classList.contains('contact-btn')
      ) {
        a.setAttribute('data-waguess-chat', 'true');
        if (label.indexOf('open service client') !== -1 || label === 'open service client') {
          a.textContent = 'Chat with us';
        }
      }
    }

    // If no CTA found on Service Client, add one in main content
    if (
      !document.querySelector('[data-waguess-chat]') &&
      (document.documentElement.classList.contains('waguess-service-client-page') ||
        document.body.classList.contains('waguess-service-client-page'))
    ) {
      var main =
        document.querySelector('main .rich-text, main .page-content, #MainContent .rich-text, #MainContent') ||
        document.querySelector('main');
      if (main) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button-1 waguess-chat-btn';
        btn.setAttribute('data-waguess-chat', 'true');
        btn.textContent = 'Chat with us';
        btn.style.marginTop = '20px';
        main.appendChild(btn);
      }
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target) return;
      var el = target.closest('a, button, [data-waguess-chat], .button, .contact-btn');
      if (!el || !isChatButton(el)) return;

      event.preventDefault();
      event.stopPropagation();
      openChatWithRetry();
    },
    true
  );

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    enhanceChatPageCtas();

    // Only auto-open if customer arrived with #waguess-chat on this page
    if (window.location.hash === CHAT_HASH) {
      setTimeout(openChatWithRetry, 500);
    }
  });

  window.WaguessOpenChat = openChatWithRetry;
})();
